import React, { useEffect, useState } from "react";
import { useHistory, useParams, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import Box from "@mui/material/Box";
import {
  Grid,
  Typography,
  Button,
  TextField,
  MenuItem,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Accordion,
  AccordionSummary,
  AccordionDetails
} from "@mui/material";
import { ExpandMore } from "@mui/icons-material";
import Layout from "../../components/Wrappers/Layout";
import { Card, Alert } from "reactstrap";
import {
  resetVoucherDetails,
  getvoucherDetailsList
} from "../../redux/actions/voucherDetailsAction";
import { makeStyles } from "@mui/styles";
import BackButton from "../../components/BackButton/BackButton";
import { IndeterminateCheckBoxSharp } from "@mui/icons-material";
import SOLogout from "../../components/Logout/SOLogout";
import regenerateToken from "../../components/RegenerateToken/regenerateToken";

const useStyles = makeStyles({
  table: {
    minWidth: 650
  }
});

const VoucherDetails = () => {
  const classes = useStyles();
  const location = useLocation();
  const voucherId = location.search.split("?userId=")[1];
  // console.log(voucherId);

  const dispatch = useDispatch();
  // const partnerloginUser = useSelector(({ login }) => login);
  // var authToken = partnerloginUser.data.AuthToken;

  const regenerateTokenRes = useSelector(
    ({ regenerateToken }) => regenerateToken
  );
  // console.log("regenerateTokenRes", regenerateTokenRes);
  var authToken = regenerateTokenRes.data.AuthToken;

  const [getVoucherDetailsStatus, SetgetVoucherDetailsStatus] = useState(false);

  const [getVoucherDetailsArray, setgetVoucherDetailsArray] = useState([]);

  const getvoucherDetailsRes = useSelector(
    ({ getvoucherDetails }) => getvoucherDetails
  );

  // console.log("getVoucherDetailsArray");
  // console.log(getVoucherDetailsArray);
  // console.log("getVoucherDetailsArray");

  const getVoucherDetailsReqApi = () => {
    SetgetVoucherDetailsStatus(true);
    const getvoucherDetailsListReq = {
      loginDetails: {
        walletOwnerId: regenerateTokenRes.data.partnerId || ""
      },
      voucherTransVO: {
        voucherId: voucherId
      }
    };

    return dispatch(
      getvoucherDetailsList(
        getvoucherDetailsListReq,
        regenerateTokenRes.data.AuthToken
      )
    );
  };

  useEffect(() => {
    if (regenerateTokenRes.data.status == "success") {
      getVoucherDetailsReqApi();
    }
  }, [regenerateTokenRes.data.status]);

  useEffect(() => {
    if (getVoucherDetailsStatus) {
      if (getvoucherDetailsRes.data.status == "success") {
        setgetVoucherDetailsArray(
          getvoucherDetailsRes.data.voucherListRequestVO
        );
      }
      if (getvoucherDetailsRes.data.status == "Failed") {
        setgetVoucherDetailsArray(getvoucherDetailsRes.data);
        if (
          getvoucherDetailsRes.data.description == "session out"
        ) {
          SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
        }
        if (
          getvoucherDetailsRes.data.description == "Authorization failed"
        ) {
          regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
        }
      }
      if (getvoucherDetailsRes.data.status == "failed") {
        setgetVoucherDetailsArray(getvoucherDetailsRes.data);
        if (
          getvoucherDetailsRes.data.description == "session out"
        ) {
          SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
        }
        if (
          getvoucherDetailsRes.data.description == "Authorization failed"
        ) {
          regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
        }
      }
      if (getvoucherDetailsRes.data.status == "NOT FOUND") {
        setgetVoucherDetailsArray(getvoucherDetailsRes.data);
      }
    }
  }, [getvoucherDetailsRes.data.status]);

  return (
    <>
      <Layout>
        <BackButton />
        <div
          style={{
            background: "white",
            paddingBottom: "1rem",
            paddingTop: "0.5rem"
          }}
        >
          <Box marginLeft={3} marginRight={3} paddingBottom={2}>
            {getVoucherDetailsArray &&
              getVoucherDetailsArray.customerDetailsVO ? (
              <div
                style={{
                  marginTop: "2rem"
                }}
              >
                <Accordion>
                  <AccordionSummary
                    expandIcon={<ExpandMore />}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                  >
                    <Typography className="themeText">
                      Customer Details
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails style={{ display: "unset" }}>
                    <>
                      <TableContainer component={Paper}>
                        {getVoucherDetailsArray &&
                          getVoucherDetailsArray.customerDetailsVO && (
                            <Table
                              className={classes.table}
                              aria-label="a dense table"
                              style={{ whiteSpace: "nowrap" }}
                            >
                              <TableHead>
                                <TableRow className="tableHeaderColor">
                                  <TableCell
                                    align="center"
                                    style={{
                                      fontWeight: "bold",
                                      color: "white"
                                    }}
                                  >
                                    Customer Id{" "}
                                  </TableCell>
                                  <TableCell
                                    align="center"
                                    style={{
                                      fontWeight: "bold",
                                      color: "white"
                                    }}
                                  >
                                    Customer Name
                                  </TableCell>
                                  <TableCell
                                    align="center"
                                    style={{
                                      fontWeight: "bold",
                                      color: "white"
                                    }}
                                  >
                                    Country Code
                                  </TableCell>
                                  <TableCell
                                    align="center"
                                    style={{
                                      fontWeight: "bold",
                                      color: "white"
                                    }}
                                  >
                                    Customer Email
                                  </TableCell>
                                </TableRow>
                              </TableHead>

                              <TableBody>
                                {getVoucherDetailsArray && (
                                  <TableRow>
                                    <TableCell align="center">
                                      {getVoucherDetailsArray.userId
                                        ? getVoucherDetailsArray.userId
                                        : "-"}
                                    </TableCell>
                                    <TableCell align="center">
                                      {/* {getVoucherDetailsArray.customerDetailsVO.contactName} */}
                                      {getVoucherDetailsArray.customerDetailsVO
                                        .contactName
                                        ? getVoucherDetailsArray
                                          .customerDetailsVO.contactName
                                        : "-"}
                                    </TableCell>
                                    <TableCell align="center">
                                      {/* {getVoucherDetailsArray.customerDetailsVO.country} */}
                                      {getVoucherDetailsArray.customerDetailsVO
                                        .country
                                        ? getVoucherDetailsArray
                                          .customerDetailsVO.country
                                        : "-"}
                                    </TableCell>
                                    <TableCell align="center">
                                      {getVoucherDetailsArray.customerDetailsVO
                                        .email
                                        ? getVoucherDetailsArray
                                          .customerDetailsVO.email
                                        : "-"}
                                    </TableCell>
                                  </TableRow>
                                )}
                              </TableBody>
                            </Table>
                          )}
                      </TableContainer>
                    </>
                  </AccordionDetails>
                </Accordion>
              </div>
            ) : (
              ""
            )}

            {/* {getVoucherDetailsArray &&
            getVoucherDetailsArray.customerDetailsVO &&
            <>
              <TableContainer component={Paper}>
                <BackButton />
                <Typography
                  variant="body1"
                  style={{
                    textAlign: "center",
                    margin: "10px 0",
                    color: "#01367e",
                    fontSize: "1.4rem",
                  }}
                >
                  Customer Details
                </Typography>

                {getVoucherDetailsArray &&
                  getVoucherDetailsArray.customerDetailsVO && (
                    <Table
                      className={classes.table}
                      aria-label="a dense table"
                      style={{ whiteSpace: "nowrap" }}
                    >
                      <TableHead>
                        <TableRow style={{ background: "#00b9f5" }}>
                          <TableCell
                            align="center"
                            style={{ fontWeight: "bold", color: "white" }}
                          >
                            Customer Id{" "}
                          </TableCell>
                          <TableCell
                            align="center"
                            style={{ fontWeight: "bold", color: "white" }}
                          >
                            Customer Name
                          </TableCell>
                          <TableCell
                            align="center"
                            style={{ fontWeight: "bold", color: "white" }}
                          >
                            Country Code
                          </TableCell>
                          <TableCell
                            align="center"
                            style={{ fontWeight: "bold", color: "white" }}
                          >
                            Customer Email
                          </TableCell>
                        </TableRow>
                      </TableHead>

                      <TableBody>
                        {getVoucherDetailsArray.customerDetailsVO && (
                          <TableRow>
                            <TableCell align="center">
                              {getVoucherDetailsArray.customerDetailsVO.customerId ? getVoucherDetailsArray.customerDetailsVO.customerId : "-"}
                            </TableCell>
                            <TableCell align="center">

                              {getVoucherDetailsArray.customerDetailsVO.contactName ? getVoucherDetailsArray.customerDetailsVO.contactName : "-"}
                            </TableCell>
                            <TableCell align="center">

                              {getVoucherDetailsArray.customerDetailsVO.country ? getVoucherDetailsArray.customerDetailsVO.country : "-"}
                            </TableCell>
                            <TableCell align="center">
                              {getVoucherDetailsArray.customerDetailsVO.email ? getVoucherDetailsArray.customerDetailsVO.email : "-"}
                            </TableCell>
                          </TableRow>
                        )}
                      </TableBody>
                    </Table>
                  )}
              </TableContainer>
            </>
          } */}

            {/* <TableContainer component={Paper}>
          <BackButton />
          <Typography
            variant="body1"
            style={{
              textAlign: "center",
              margin: "10px 0",
              color: "#01367e",
              fontSize: "1.4rem",
            }}
          >
            Customer Details
          </Typography>

          {getVoucherDetailsArray &&
            getVoucherDetailsArray.customerDetailsVO && (
              <Table
                className={classes.table}
                aria-label="a dense table"
                style={{ whiteSpace: "nowrap" }}
              >
                <TableHead>
                  <TableRow style={{ background: "#00b9f5" }}>
                    <TableCell
                      align="center"
                      style={{ fontWeight: "bold", color: "white" }}
                    >
                      Customer Id{" "}
                    </TableCell>
                    <TableCell
                      align="center"
                      style={{ fontWeight: "bold", color: "white" }}
                    >
                      Customer Name
                    </TableCell>
                    <TableCell
                      align="center"
                      style={{ fontWeight: "bold", color: "white" }}
                    >
                      Country Code
                    </TableCell>
                    <TableCell
                      align="center"
                      style={{ fontWeight: "bold", color: "white" }}
                    >
                      Customer Email
                    </TableCell>
                  </TableRow>
                </TableHead>

                <TableBody>
                  {getVoucherDetailsArray && (
                    <TableRow key={getVoucherDetailsArray.customerDetailsVO.customerId}>
                      <TableCell align="center">
                        {getVoucherDetailsArray.customerDetailsVO.customerId}
                      </TableCell>
                      <TableCell align="center">
                        {getVoucherDetailsArray.customerDetailsVO.contactName}
                      </TableCell>
                      <TableCell align="center">
                        {getVoucherDetailsArray.customerDetailsVO.country}
                      </TableCell>
                      <TableCell align="center">
                        {getVoucherDetailsArray.customerDetailsVO.email}
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            )}
        </TableContainer> */}

            <div
              style={{
                marginTop: "2rem"
              }}
            >
              <Accordion>
                <AccordionSummary
                  expandIcon={<ExpandMore />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                >
                  <Typography className="themeText">Voucher Details</Typography>
                </AccordionSummary>
                <AccordionDetails style={{ display: "unset" }}>
                  <TableContainer component={Paper}>
                    {getVoucherDetailsArray && getVoucherDetailsArray && (
                      <Table
                        className={classes.table}
                        aria-label="a dense table"
                        style={{ whiteSpace: "nowrap" }}
                      >
                        <TableHead>
                          <TableRow className="tableHeaderColor">
                            <TableCell
                              align="center"
                              style={{ fontWeight: "bold", color: "white" }}
                            >
                              Voucher Id{" "}
                            </TableCell>
                            <TableCell
                              align="center"
                              style={{ fontWeight: "bold", color: "white" }}
                            >
                              Voucher Number
                            </TableCell>
                            <TableCell
                              align="center"
                              style={{ fontWeight: "bold", color: "white" }}
                            >
                              Voucher Type
                            </TableCell>
                            <TableCell
                              align="center"
                              style={{ fontWeight: "bold", color: "white" }}
                            >
                              Voucher Status
                            </TableCell>
                            <TableCell
                              align="center"
                              style={{ fontWeight: "bold", color: "white" }}
                            >
                              Voucher Amount{" "}
                            </TableCell>
                            <TableCell
                              align="center"
                              style={{ fontWeight: "bold", color: "white" }}
                            >
                              Voucher Currency
                            </TableCell>
                            <TableCell
                              align="center"
                              style={{ fontWeight: "bold", color: "white" }}
                            >
                              Creation Date
                            </TableCell>
                            <TableCell
                              align="center"
                              style={{ fontWeight: "bold", color: "white" }}
                            >
                              Activation Date
                            </TableCell>
                            <TableCell
                              align="center"
                              style={{ fontWeight: "bold", color: "white" }}
                            >
                              Expiry Date
                            </TableCell>
                            <TableCell
                              align="center"
                              style={{ fontWeight: "bold", color: "white" }}
                            >
                              Redeem Date
                            </TableCell>
                          </TableRow>
                        </TableHead>

                        <TableBody>
                          {getVoucherDetailsArray &&
                            []
                              .concat(getVoucherDetailsArray)
                              .map((row, index) => (
                                <TableRow key={index}>
                                  <TableCell align="center">
                                    {row.voucherId ? row.voucherId : "-"}
                                  </TableCell>
                                  <TableCell align="center">
                                    {row.voucherNumber
                                      ? row.voucherNumber
                                      : "-"}
                                  </TableCell>
                                  <TableCell align="center">
                                    {row.voucherType ? row.voucherType : "-"}
                                  </TableCell>
                                  <TableCell align="center">
                                    {" "}
                                    {row.status ? row.status : "-"}
                                  </TableCell>
                                  <TableCell align="center">
                                    {row.amount ? row.amount : "-"}
                                  </TableCell>
                                  <TableCell align="center">
                                    {row.currency ? row.currency : "-"}
                                  </TableCell>
                                  <TableCell align="center">
                                    {row.creationDate ? row.creationDate : "-"}
                                  </TableCell>
                                  <TableCell align="center">
                                    {row.activationDate
                                      ? row.activationDate
                                      : "-"}
                                  </TableCell>
                                  <TableCell align="center">
                                    {row.expiryDate ? row.expiryDate : "-"}
                                  </TableCell>
                                  <TableCell align="center">
                                    {row.redeemDate ? row.redeemDate : "-"}
                                  </TableCell>
                                </TableRow>
                              ))}
                        </TableBody>
                      </Table>
                    )}
                  </TableContainer>
                </AccordionDetails>
              </Accordion>
            </div>

            {/* <TableContainer component={Paper} style={{ marginTop: "15px" }}>
              <Typography
                variant="body1"
                style={{
                  textAlign: "center",
                  margin: "10px 0",
                  color: "#01367e",
                  fontSize: "1.4rem",
                }}
              >
                Voucher Details
              </Typography>

              {getVoucherDetailsArray && getVoucherDetailsArray && (
                <Table
                  className={classes.table}
                  aria-label="a dense table"
                  style={{ whiteSpace: "nowrap" }}
                >
                  <TableHead>
                    <TableRow style={{ background: "#00b9f5" }}>
                      <TableCell
                        align="center"
                        style={{ fontWeight: "bold", color: "white" }}
                      >
                        Voucher Id{" "}
                      </TableCell>
                      <TableCell
                        align="center"
                        style={{ fontWeight: "bold", color: "white" }}
                      >
                        Voucher Number
                      </TableCell>
                      <TableCell
                        align="center"
                        style={{ fontWeight: "bold", color: "white" }}
                      >
                        Voucher Type
                      </TableCell>
                      <TableCell
                        align="center"
                        style={{ fontWeight: "bold", color: "white" }}
                      >
                        Voucher Status
                      </TableCell>
                      <TableCell
                        align="center"
                        style={{ fontWeight: "bold", color: "white" }}
                      >
                        Voucher Amount{" "}
                      </TableCell>
                      <TableCell
                        align="center"
                        style={{ fontWeight: "bold", color: "white" }}
                      >
                        Voucher Currency
                      </TableCell>
                      <TableCell
                        align="center"
                        style={{ fontWeight: "bold", color: "white" }}
                      >
                        Creation Date
                      </TableCell>
                      <TableCell
                        align="center"
                        style={{ fontWeight: "bold", color: "white" }}
                      >
                        Activation Date
                      </TableCell>
                      <TableCell
                        align="center"
                        style={{ fontWeight: "bold", color: "white" }}
                      >
                        Expiry Date
                      </TableCell>
                      <TableCell
                        align="center"
                        style={{ fontWeight: "bold", color: "white" }}
                      >
                        Redeem Date
                      </TableCell>
                    </TableRow>
                  </TableHead>

                  <TableBody>
                    {getVoucherDetailsArray &&
                      [].concat(getVoucherDetailsArray).map((row, index) => (
                        <TableRow key={index}>
                          <TableCell align="center">{row.voucherId ? row.voucherId : "-"}</TableCell>
                          <TableCell align="center">{row.voucherNumber ? row.voucherNumber : "-"}</TableCell>
                          <TableCell align="center">{row.voucherType ? row.voucherType : "-"}</TableCell>
                          <TableCell align="center"> {row.status ? row.status : "-"}</TableCell>
                          <TableCell align="center">{row.amount ? row.amount : "-"}</TableCell>
                          <TableCell align="center">{row.currency ? row.currency : "-"}</TableCell>
                          <TableCell align="center">{row.creationDate ? row.creationDate : "-"}</TableCell>
                          <TableCell align="center">{row.activationDate ? row.activationDate : "-"}</TableCell>
                          <TableCell align="center">{row.expiryDate ? row.expiryDate : "-"}</TableCell>
                          <TableCell align="center">{row.redeemDate ? row.redeemDate : "-"}</TableCell>
                        </TableRow>
                      ))}
                  </TableBody>
                </Table>
              )}
            </TableContainer> */}

            {/* {
        getVoucherDetailsArray.voucherListRequestVO && 
        getVoucherDetailsArray.voucherListRequestVO.voucherHistoryVOList ? 
        (<>
          <TableContainer component={Paper} style={{ marginTop: "15px" }}>
          <Typography
            variant="body1"
            style={{
              textAlign: "center",
              margin: "10px 0",
              color: "#01367e",
              fontSize: "1.4rem",
            }}
          >
            Voucher History
          </Typography>


          <Table
            className={classes.table}
            aria-label="a dense table"
            style={{ whiteSpace: "nowrap" }}
          >
            <TableHead>
              <TableRow style={{ background: "#00b9f5" }}>
                <TableCell
                  align="center"
                  style={{ fontWeight: "bold", color: "white" }}
                >
                  Status{" "}
                </TableCell>
                <TableCell
                  align="center"
                  style={{ fontWeight: "bold", color: "white" }}
                >
                  Timestamp
                </TableCell>
                <TableCell
                  align="center"
                  style={{ fontWeight: "bold", color: "white" }}
                >
                  Voucher Currency{" "}
                </TableCell>
                <TableCell
                  align="center"
                  style={{ fontWeight: "bold", color: "white" }}
                >
                  Voucher Amount
                </TableCell>
                <TableCell
                  align="center"
                  style={{ fontWeight: "bold", color: "white" }}
                >
                  Redeem Currency
                </TableCell>
                <TableCell
                  align="center"
                  style={{ fontWeight: "bold", color: "white" }}
                >
                  Redeem Amount
                </TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {getVoucherDetailsArray.voucherHistoryVOList &&
                []
                  .concat(getVoucherDetailsArray.voucherHistoryVOList) &&
                getVoucherDetailsArray.voucherHistoryVOList
                  .map((row, index) => (
                    <TableRow key={index}>
                      <TableCell align="center">{row.status}</TableCell>
                      <TableCell align="center">{row.timeStamp}</TableCell>
                      <TableCell align="center">
                        {row.purchaseCurrency}
                      </TableCell>
                      <TableCell align="center">
                        {row.purchaseAmount}
                      </TableCell>
                      <TableCell align="center">
                        {row.redeemCurrency}
                      </TableCell>
                    </TableRow>
                  ))}
            </TableBody>
          </Table>

        </TableContainer>
        </>):
        ("")

      } */}

            <div
              style={{
                marginTop: "2rem"
              }}
            >
              <Accordion>
                <AccordionSummary
                  expandIcon={<ExpandMore />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                >
                  <Typography className="themeText">Voucher History</Typography>
                </AccordionSummary>
                <AccordionDetails style={{ display: "unset" }}>
                  <TableContainer component={Paper}>
                    <Table
                      className={classes.table}
                      aria-label="a dense table"
                      style={{ whiteSpace: "nowrap" }}
                    >
                      <TableHead>
                        <TableRow className="tableHeaderColor">
                          <TableCell
                            align="center"
                            style={{ fontWeight: "bold", color: "white" }}
                          >
                            Status{" "}
                          </TableCell>
                          <TableCell
                            align="center"
                            style={{ fontWeight: "bold", color: "white" }}
                          >
                            Timestamp
                          </TableCell>
                          <TableCell
                            align="center"
                            style={{ fontWeight: "bold", color: "white" }}
                          >
                            Voucher Currency{" "}
                          </TableCell>
                          <TableCell
                            align="center"
                            style={{ fontWeight: "bold", color: "white" }}
                          >
                            Voucher Amount
                          </TableCell>
                          <TableCell
                            align="center"
                            style={{ fontWeight: "bold", color: "white" }}
                          >
                            Redeem Currency
                          </TableCell>
                          <TableCell
                            align="center"
                            style={{ fontWeight: "bold", color: "white" }}
                          >
                            Redeem Amount
                          </TableCell>
                        </TableRow>
                      </TableHead>

                      <TableBody>
                        {getVoucherDetailsArray.voucherHistoryVOList &&
                          []
                            .concat(getVoucherDetailsArray.voucherHistoryVOList)
                            .map((row, index) => (
                              <TableRow key={index}>
                                <TableCell align="center">
                                  {row.status ? row.status : "-"}
                                </TableCell>
                                <TableCell align="center">
                                  {row.timeStamp ? row.timeStamp : "-"}
                                </TableCell>
                                <TableCell align="center">
                                  {row.purchaseCurrency
                                    ? row.purchaseCurrency
                                    : "-"}
                                </TableCell>
                                <TableCell align="center">
                                  {row.purchaseAmount
                                    ? row.purchaseAmount
                                    : "-"}
                                </TableCell>
                                <TableCell align="center">
                                  {row.redeemCurrency
                                    ? row.redeemCurrency
                                    : "-"}
                                </TableCell>
                                <TableCell align="center">
                                  {row.redeemAmount ? row.redeemAmount : "-"}
                                </TableCell>
                              </TableRow>
                            ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </AccordionDetails>
              </Accordion>
            </div>

            {/* <TableContainer component={Paper} style={{ marginTop: "15px" }}>
              <Typography
                variant="body1"
                style={{
                  textAlign: "center",
                  margin: "10px 0",
                  color: "#01367e",
                  fontSize: "1.4rem",
                }}
              >
                Voucher History
              </Typography>


              <Table
                className={classes.table}
                aria-label="a dense table"
                style={{ whiteSpace: "nowrap" }}
              >
                <TableHead>
                  <TableRow style={{ background: "#00b9f5" }}>
                    <TableCell
                      align="center"
                      style={{ fontWeight: "bold", color: "white" }}
                    >
                      Status{" "}
                    </TableCell>
                    <TableCell
                      align="center"
                      style={{ fontWeight: "bold", color: "white" }}
                    >
                      Timestamp
                    </TableCell>
                    <TableCell
                      align="center"
                      style={{ fontWeight: "bold", color: "white" }}
                    >
                      Voucher Currency{" "}
                    </TableCell>
                    <TableCell
                      align="center"
                      style={{ fontWeight: "bold", color: "white" }}
                    >
                      Voucher Amount
                    </TableCell>
                    <TableCell
                      align="center"
                      style={{ fontWeight: "bold", color: "white" }}
                    >
                      Redeem Currency
                    </TableCell>
                    <TableCell
                      align="center"
                      style={{ fontWeight: "bold", color: "white" }}
                    >
                      Redeem Amount
                    </TableCell>
                  </TableRow>
                </TableHead>

                <TableBody>
                  {getVoucherDetailsArray.voucherHistoryVOList &&
                    []
                      .concat(getVoucherDetailsArray.voucherHistoryVOList) &&
                    getVoucherDetailsArray.voucherHistoryVOList
                      .map((row, index) => (
                        <TableRow key={index}>
                          <TableCell align="center">{row.status ? row.status : "-"}</TableCell>
                          <TableCell align="center">{row.timeStamp ? row.timeStamp : "-"}</TableCell>
                          <TableCell align="center">
                            {row.purchaseCurrency ? row.purchaseCurrency : "-"}
                          </TableCell>
                          <TableCell align="center">
                            {row.purchaseAmount ? row.purchaseAmount : "-"}
                          </TableCell>
                          <TableCell align="center">
                            {row.redeemCurrency ? row.redeemCurrency : "-"}
                          </TableCell>
                          <TableCell align="center">
                            {row.redeemAmount ? row.redeemAmount : "-"}
                          </TableCell>
                        </TableRow>
                      ))}
                </TableBody>
              </Table>

            </TableContainer> */}

            {/* {
          getVoucherDetailsArray &&
            getVoucherDetailsArray ?
            (<>
              <TableContainer component={Paper} style={{ marginTop: "15px" }}>
                <Typography
                  variant="body1"
                  style={{
                    textAlign: "center",
                    margin: "10px 0",
                    color: "#01367e",
                    fontSize: "1.4rem",
                  }}
                >
                  Transaction Details
                </Typography>

                {getVoucherDetailsArray && (
                  <Table
                    className={classes.table}
                    aria-label="a dense table"
                    style={{ whiteSpace: "nowrap" }}
                  >
                    <TableHead>
                      <TableRow style={{ background: "#00b9f5" }}>
                        <TableCell
                          align="center"
                          style={{ fontWeight: "bold", color: "white" }}
                        >
                          Tracking Id
                        </TableCell>
                        <TableCell
                          align="center"
                          style={{ fontWeight: "bold", color: "white" }}
                        >
                          Voucher Amount
                        </TableCell>
                        <TableCell
                          align="center"
                          style={{ fontWeight: "bold", color: "white" }}
                        >
                          Voucher Currency
                        </TableCell>
                        <TableCell
                          align="center"
                          style={{ fontWeight: "bold", color: "white" }}
                        >
                          Action
                        </TableCell>
                        <TableCell
                          align="center"
                          style={{ fontWeight: "bold", color: "white" }}
                        >
                          Redeem Amount
                        </TableCell>
                        <TableCell
                          align="center"
                          style={{ fontWeight: "bold", color: "white" }}
                        >
                          Redeem Currency{" "}
                        </TableCell>
                        <TableCell
                          align="center"
                          style={{ fontWeight: "bold", color: "white" }}
                        >
                          Transaction Date
                        </TableCell>
                        <TableCell
                          align="center"
                          style={{ fontWeight: "bold", color: "white" }}
                        >
                          Status
                        </TableCell>
                      </TableRow>
                    </TableHead>

                    <TableBody>
                      {getVoucherDetailsArray &&
                        getVoucherDetailsArray &&
                        [].concat(getVoucherDetailsArray).map((row, index) => (
                          <TableRow key={index}>
                            <TableCell align="center">{row.trackingId}</TableCell>
                            <TableCell align="center">{row.voucherAmount}</TableCell>
                            <TableCell align="center">
                              {row.voucherCurrency}
                            </TableCell>
                            <TableCell align="center">{row.action}</TableCell>
                            <TableCell align="center"></TableCell>
                            <TableCell align="center"></TableCell>
                            <TableCell align="center">{row.timestamp}</TableCell>
                            <TableCell align="center">{row.status}</TableCell>
                          </TableRow>
                        ))}
                    </TableBody>
                  </Table>
                )}
              </TableContainer>
            </>)
            :
            ("")
        } */}

            <div
              style={{
                marginTop: "2rem"
              }}
            >
              <Accordion>
                <AccordionSummary
                  expandIcon={<ExpandMore />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                >
                  <Typography className="themeText">
                    Transaction Details
                  </Typography>
                </AccordionSummary>
                <AccordionDetails style={{ display: "unset" }}>
                  <TableContainer component={Paper}>
                    {getVoucherDetailsArray && (
                      <Table
                        className={classes.table}
                        aria-label="a dense table"
                        style={{ whiteSpace: "nowrap" }}
                      >
                        <TableHead>
                          <TableRow className="tableHeaderColor">
                            <TableCell
                              align="center"
                              style={{ fontWeight: "bold", color: "white" }}
                            >
                              Tracking Id
                            </TableCell>
                            <TableCell
                              align="center"
                              style={{ fontWeight: "bold", color: "white" }}
                            >
                              Voucher Amount
                            </TableCell>
                            <TableCell
                              align="center"
                              style={{ fontWeight: "bold", color: "white" }}
                            >
                              Voucher Currency
                            </TableCell>
                            <TableCell
                              align="center"
                              style={{ fontWeight: "bold", color: "white" }}
                            >
                              Action
                            </TableCell>
                            <TableCell
                              align="center"
                              style={{ fontWeight: "bold", color: "white" }}
                            >
                              Redeem Amount
                            </TableCell>
                            <TableCell
                              align="center"
                              style={{ fontWeight: "bold", color: "white" }}
                            >
                              Redeem Currency{" "}
                            </TableCell>
                            <TableCell
                              align="center"
                              style={{ fontWeight: "bold", color: "white" }}
                            >
                              Transaction Date
                            </TableCell>
                            <TableCell
                              align="center"
                              style={{ fontWeight: "bold", color: "white" }}
                            >
                              Status
                            </TableCell>
                          </TableRow>
                        </TableHead>

                        <TableBody>
                          {getVoucherDetailsArray &&
                            getVoucherDetailsArray &&
                            []
                              .concat(getVoucherDetailsArray)
                              .map((row, index) => (
                                <TableRow key={index}>
                                  <TableCell align="center">
                                    {row.trackingId ? row.trackingId : "-"}
                                  </TableCell>
                                  <TableCell align="center">
                                    {row.voucherAmount
                                      ? row.voucherAmount
                                      : "-"}
                                  </TableCell>
                                  <TableCell align="center">
                                    {row.voucherCurrency
                                      ? row.voucherCurrency
                                      : "-"}
                                  </TableCell>
                                  <TableCell align="center">
                                    {row.action ? row.action : "-"}
                                  </TableCell>
                                  <TableCell align="center">{"-"}</TableCell>
                                  <TableCell align="center">{"-"}</TableCell>
                                  <TableCell align="center">
                                    {row.timestamp ? row.timestamp : "-"}
                                  </TableCell>
                                  <TableCell align="center">
                                    {row.status ? row.status : "-"}
                                  </TableCell>
                                </TableRow>
                              ))}
                        </TableBody>
                      </Table>
                    )}
                  </TableContainer>
                </AccordionDetails>
              </Accordion>
            </div>

            {/* <TableContainer component={Paper} style={{ marginTop: "15px" }}>
              <Typography
                variant="body1"
                style={{
                  textAlign: "center",
                  margin: "10px 0",
                  color: "#01367e",
                  fontSize: "1.4rem",
                }}
              >
                Transaction Details
              </Typography>

              {getVoucherDetailsArray && (
                <Table
                  className={classes.table}
                  aria-label="a dense table"
                  style={{ whiteSpace: "nowrap" }}
                >
                  <TableHead>
                    <TableRow style={{ background: "#00b9f5" }}>
                      <TableCell
                        align="center"
                        style={{ fontWeight: "bold", color: "white" }}
                      >
                        Tracking Id
                      </TableCell>
                      <TableCell
                        align="center"
                        style={{ fontWeight: "bold", color: "white" }}
                      >
                        Voucher Amount
                      </TableCell>
                      <TableCell
                        align="center"
                        style={{ fontWeight: "bold", color: "white" }}
                      >
                        Voucher Currency
                      </TableCell>
                      <TableCell
                        align="center"
                        style={{ fontWeight: "bold", color: "white" }}
                      >
                        Action
                      </TableCell>
                      <TableCell
                        align="center"
                        style={{ fontWeight: "bold", color: "white" }}
                      >
                        Redeem Amount
                      </TableCell>
                      <TableCell
                        align="center"
                        style={{ fontWeight: "bold", color: "white" }}
                      >
                        Redeem Currency{" "}
                      </TableCell>
                      <TableCell
                        align="center"
                        style={{ fontWeight: "bold", color: "white" }}
                      >
                        Transaction Date
                      </TableCell>
                      <TableCell
                        align="center"
                        style={{ fontWeight: "bold", color: "white" }}
                      >
                        Status
                      </TableCell>
                    </TableRow>
                  </TableHead>

                  <TableBody>
                    {getVoucherDetailsArray &&
                      getVoucherDetailsArray &&
                      [].concat(getVoucherDetailsArray).map((row, index) => (
                        <TableRow key={index}>
                          <TableCell align="center">{row.trackingId ? row.trackingId : "-"}</TableCell>
                          <TableCell align="center">{row.voucherAmount ? row.voucherAmount : "-"}</TableCell>
                          <TableCell align="center">
                            {row.voucherCurrency ? row.voucherCurrency : "-"}
                          </TableCell>
                          <TableCell align="center">{row.action ? row.action : "-"}</TableCell>
                          <TableCell align="center">{"-"}</TableCell>
                          <TableCell align="center">{"-"}</TableCell>
                          <TableCell align="center">{row.timestamp ? row.timestamp : "-"}</TableCell>
                          <TableCell align="center">{row.status ? row.status : "-"}</TableCell>
                        </TableRow>
                      ))}
                  </TableBody>
                </Table>
              )}
            </TableContainer> */}
          </Box>
        </div>
      </Layout>
    </>
  );
};

export default VoucherDetails;
